import { Section } from "@components/ui/Section";
import styles from "./layout.module.css";

export const LandingFooter = () => (
  <footer>
    <Section className={`${styles.footerBg} ${styles.footerText} ${styles.footerSection}`}>
      <div className={styles.footerContainer}>
        <div className={styles.footerGrid}>
          <img
            className={styles.footerLogo}
            src="/Woolworths MarketPlus-Primary-Inverted.svg"
            alt="logo"
            width={215}
            height={58}
            style={{ objectFit: "contain" }}
          />
          <div className={`${styles.footerLinksCol} ${styles.footerLinks}`}>
            <h4 className={styles.footerHeading}>Useful links</h4>
            <a href="https://www.woolworths.com.au/shop/discover/everyday-market">
              Everyday Market
            </a>
            <a href="https://www.bigw.com.au/marketplace">BIG W Market</a>
            <a
              href="http://www.woolworthsgroup.com.au"
              rel="noopener noreferrer"
            >
              Woolworths Group
            </a>
            <a href="/terms-and-conditions">Terms</a>
            <a href="/seller-policies">Seller Policies</a>
          </div>
          <div className={`${styles.footerLinksCol} ${styles.footerLinks}`}>
            <h4 className={styles.footerHeading}>Already a seller?</h4>
            <a href="https://portal.mydeal.com.au/">Woolworths MarketPlus Portal</a>
          </div>
        </div>

        <hr className={styles.footerDivider} />

        <div className={styles.footerSub}>
          <img
            className={styles.footerSubLogo}
            src="/care_deeply.svg"
            alt="Sub Footer"
            width={79}
            height={64}
            style={{ objectFit: "contain" }}
          />
          <div className={styles.footerSubText}>
            <div className={styles.footerSubTextBlock}>
              We acknowledge the Traditional Owners and Custodians of Country
              throughout Australia. We pay our respects to all First Nations
              peoples and acknowledge Elders past and present.
            </div>
            <a
              className={styles.footerSubLink}
              title="Reconciliation at Woolworths Group"
              href="https://www.woolworthsgroup.com.au/au/en/our-impact/reconciliation/reconciliation-at-woolworths-group.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Read more about our commitment to reconciliation
            </a>
            <div>Woolworths MarketPlus 2025 ©</div>
          </div>
        </div>
      </div>
    </Section>
  </footer>
);

/* Add the following to layout.module.css:
.footerLinks a:hover {
  text-decoration: underline;
}
.footerLinkHover:hover {
  color: var(--color-footer-link);
}
*/
